module.exports = __webpack_public_path__ + "static/media/eye.2742e429.svg";